<template>
  <div class="page-wrapper">
    <common :add="true"></common>
  </div>
</template>
 
<script type="text/ecmascript-6">
import { getSelectedData } from 'api/archives.js'
import Common from './../components/Common'
export default {
  name:'addgoods',
  components:{
    Common
  },
  mounted(){
  },
  data () {
    return {
    }
 }
}
</script>
